<template>
  <v-row class="justify-center">
    <v-col
      cols="12"
      sm="6">
      <v-card
        class="pa-10 text-center"
        :disabled="disabled"
        v-bind="activeProps('basic')">
        <img
          :src="isSelected('basic') ? '/img/order/basic-package-white.png' : '/img/order/basic-package.png'"
          height="191">
        <div class="py-4 font-weight-bold _fs-36">
          Basic
        </div>
        <v-btn
          class="package-btn"
          rounded
          outlined
          :color="isSelected('basic') ? 'white' : 'primary'"
          @click="updatePackagePlan('basic')">
          เลือกแพ็กเกจบรอดแคสต์
        </v-btn>
        <v-btn
          class="mt-4 _w-100pct"
          style="text-decoration: underline;"
          text
          :color="isSelected('basic') ? 'white' : 'primary'"
          @click="openDetailDialog('basic')">
          อ่านรายละเอียด
        </v-btn>
      </v-card>
    </v-col>

    <v-col
      cols="12"
      sm="6">
      <v-card
        class="pa-10 text-center fill-height"
        :disabled="disabled"
        v-bind="activeProps('pro')">
        <img
          :src="isSelected('pro') ? '/img/order/pro-package-white.png' : '/img/order/pro-package.png'"
          height="191">
        <div class="py-4 font-weight-bold _fs-36">
          Pro
        </div>
        <v-btn
          class="package-btn"
          rounded
          outlined
          :color="isSelected('pro') ? 'white' : 'primary'"
          @click="updatePackagePlan('pro')">
          เลือกแพ็กเกจบรอดแคสต์
        </v-btn>
        <v-btn
          class="mt-4 _w-100pct"
          style="text-decoration: underline;"
          text
          :color="isSelected('pro') ? 'white' : 'primary'"
          @click="openDetailDialog('pro')">
          อ่านรายละเอียด
        </v-btn>
      </v-card>
    </v-col>

    <v-dialog
      v-model="detailActive"
      max-width="600">
      <v-card class="pa-8">
        <div class="text-center _fs-20">
          รายละเอียดแพ็กเกจรายเดือน
        </div>
        <div class="text-center mt-4 _fs-20">
          LINE Official Account <br class="d-sm-none">
          <span class="error--text">(แพ็กเกจจะถูกตัดทุก ๆ สิ้นเดือน)</span>
        </div>
        <v-simple-table class="mt-8 mb-4">
          <thead>
            <tr>
              <th
                class="font-weight-bold primary white--text text-center"
                colspan="2">
                <div class="text-capitalize _fs-20">
                  {{ detailPackagePlan }}
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="text-center">
                <div class="_fs-16">
                  ราคาแพ็กเกจ
                </div>
              </td>
              <td class="text-center">
                <div class="_fs-16">
                  {{ selectedDetailItemData.packagePrice | numberComma }} บาท
                </div>
              </td>
            </tr>
            <tr>
              <td class="text-center">
                <div class="_fs-16">
                  จำนวนข้อความฟรี
                </div>
              </td>
              <td class="text-center">
                <div class="_fs-16">
                  {{ selectedDetailItemData.messageQty | numberComma }} ข้อความ
                </div>
              </td>
            </tr>
            <tr>
              <td class="text-center">
                <div class="_fs-16">
                  ราคาต่อข้อความที่เกินจากฟรี
                </div>
              </td>
              <td class="text-center">
                <div class="_fs-16">
                  {{ selectedDetailItemData.messageUnitPrice }}
                  <br class="d-sm-none"> บาท / ข้อความ
                </div>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
        <div
          v-if="detailPackagePlan != 'basic'"
          class="text-center _fs-14">
          <span class="error--text">
            * ราคาจะปรับตั้งแต่วันที่ 1 สิงหาคม 2024 เป็นต้นไป<br>
            หากต้องการสั่งซื้อราคาข้อความเพิ่มเติม 0.04 เพื่อใช้ในเดือนกรกฎาคม<br>
            กรุณาส่งอีเมลขอใบเสนอราคาได้ที่อีเมล
          </span>
          <a
            href="mailto:lineagency@sellsuki.com"
            class="error--text text-decoration-underline">
            lineagency@sellsuki.com
          </a>
        </div>
        <div class="error--text text-center mt-2 _fs-14">
          * ราคาดังกล่าวไม่รวมภาษีมูลค่าเพิ่ม 7%
        </div>

        <div class="mt-8 text-center">
          <v-btn
            color="primary"
            outlined
            rounded
            width="150px"
            @click="setDetailDialog(false)">
            ปิด
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'OrderPackagePlanProduct',
  props: {
    packagePlan: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      detailActive: false,
      detailItemData: {
        basic: {
          packagePrice: 1280,
          messageQty: 15000,
          messageUnitPrice: 0.1
        },
        pro: {
          packagePrice: 1780,
          messageQty: 35000,
          messageUnitPrice: 0.06
        }
      },
      detailPackagePlan: 'basic'
    }
  },
  computed: {
    ...mapState('User', ['userProfile']),
    lineUid() {
      return this.userProfile?.uid || null
    },
    ...mapGetters({
      activeLineOfficialAccount: 'User/activeLineOfficialAccount'
    }),
    selectedDetailItemData () {
      return this.detailItemData[this.detailPackagePlan]
    }
  },
  methods: {
    updatePackagePlan (value) {
      const label = value === 'basic' ? 'new_btn_package_b' : 'new_btn_package_p'

      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'click_update_package_plan',
        category: 'user_action',
        label,
        value: 1,
        userId: this.lineUid,
        premium_id: this.activeLineOfficialAccount.premiumId || null,
        basic_id: this.activeLineOfficialAccount.basicId || null,
        customer_status: this.activeLineOfficialAccount.isOldAccount ? 'existing' : 'new'
      })
      this.$emit('update:package-plan', value)
    },
    isSelected (value) {
      return this.packagePlan === value
    },
    activeProps (value) {
      if (this.isSelected(value)) {
        return {
          dark: true,
          color: 'primary',
          style: { opacity: '0.7' }
        }
      }

      return {}
    },
    openDetailDialog (packagePlan) {
      this.detailActive = true
      this.detailPackagePlan = packagePlan
    },
    setDetailDialog (value) {
      this.detailActive = value
    }
  }
}
</script>

<style scoped>
.package-btn {
  padding: 8px 24px !important;
  height: auto !important;
}
</style>
